/**
 * Filters out given entries from the object and returns it as new instance.
 * @param object object to filter
 * @param filter - filter function to determine if entry should be kept
 */

export function pick<T extends object>(
    object: T,
    filter: (value: any, key: keyof T) => boolean,
): Partial<T> {
    return Object.fromEntries(
        Object.entries(object).filter(([key, value]) => filter(value, key as keyof T)),
    ) as Partial<T>;
}
